import type { WebInstrumentCalendarView } from '@/shared/types/web'

type NonTaskCalendarRows = Pick<
  WebInstrumentCalendarView,
  'failureRow' | 'serviceReportRow' | 'statusChangesRow' | 'departmentMovedRow' | 'unscheduledRow'
>

/** True when Failure / Status / Unscheduled / Service / Dept rows have displayable cells. */
export const hasNonTaskCalendarContent = (calendar: NonTaskCalendarRows): boolean =>
  calendar.failureRow.cells.some((cell) => cell.failureCount > 0) ||
  [
    calendar.serviceReportRow,
    calendar.statusChangesRow,
    calendar.departmentMovedRow,
    calendar.unscheduledRow,
  ].some((extraRow) => extraRow.cells.some((cell) => cell.eventCount > 0))
